import "../App.css";
import "../styling/About.css";
import FoundersHeadshot from "../images/about/founders_headshot.jpg";

// Boostrap Imports
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Container from "react-bootstrap/Container";

function About() {
  return (
    <div id="about_page" className="about_background">
      <Tab.Container>
        <Row>
          <Tab.Content>
            <Container className="tab_header">
              <h3>ABOUT US</h3>
              <Row>
                <Col sm={4}>
                  <img
                    className="tab_image"
                    src={FoundersHeadshot}
                    alt=""
                  ></img>
                  <p
                    className="credit"
                    style={{ textAlign: "center", fontSize: "x-small" }}
                  >
                    Image by Owen Burnham 2025
                  </p>
                </Col>
                <Col sm={8}>
                  <p className="tab_content" style={{ textAlign: "left" }}>
                    <b>Taylor Schmuelgen</b> is a Brooklyn based cultural
                    worker, producer, and lover of performance. She is invested
                    in supporting performing artists through both her work in
                    fundraising and nonprofit consulting with Advance
                    Collaborative and her own artistic projects. She believes
                    deeply in the power of collaboration, creativity and a good
                    cup of coffee to spark conversation and build community and
                    seeks to be a change maker in the field of experimental
                    performance.
                  </p>

                  <p className="tab_content" style={{ textAlign: "left" }}>
                    <b>Kayla White</b> is a Brooklyn based movement artist,
                    producer, and Pilates instructor. She is an advocate for
                    opportunity: for both deep trust in ourselves and our
                    community. Her artistic practices and teaching practice both
                    heavily rely upon rigor and effort in conversation with
                    relentless softening of self to listen more to our bodies
                    and our surroundings.
                  </p>

                  <p className="tab_content" style={{ textAlign: "left" }}>
                    Together they curate and produce{" "}
                    <b>
                      <i>THAT SHOW</i>
                    </b>
                    , a community gathering and showcase of early career
                    performance artists. Informed by a shared vision of a
                    performance space that provides financial and operational
                    support for risk taking and collaboration, their curatorial
                    style has been described as “rooted in TLC: tender loving
                    care” and one that “makes room for unbridled expression.”
                    Taking place at Judson Memorial Church, we embrace a messy,
                    do-it-yourself, community centered model to present and
                    present multiple works in one evening, followed by a DJ set
                    and after-party.
                  </p>
                  <p className="tab_content" style={{ textAlign: "left" }}>
                    In producing{" "}
                    <b>
                      <i>THAT SHOW</i>
                    </b>
                    , we value:
                    <ul>
                      <li>
                        Prioritizing financial compensation for presented
                        artists
                      </li>
                      <li>
                        Finding space for rehearsals, mistakes, and new
                        discoveries
                      </li>
                      <li>
                        Inviting anyone and everyone to join the party (are you
                        going to see{" "}
                        <b>
                          <i>THAT SHOW</i>
                        </b>
                        ??)
                      </li>
                      <li>Putting performances in new spaces</li>
                      <li>Continuing the conversation</li>
                      <li>Cross-disciplinary collaboration</li>
                      <li>
                        Wholeheartedly supporting our friends and colleagues
                      </li>
                      <li>
                        Creating new work OR doing the same thing over and over
                        again (if it ain’t broke!)
                      </li>
                    </ul>
                  </p>
                  <p className="tab_content" style={{ textAlign: "left" }}>
                    <a href="https://www.culturebot.org/2025/05/100470/on-formulating-of-a-dance-ecosystem-a-conversation-taylor-schmuelgen-and-kayla-white-producers-of-that-show/">
                      Link to a conversation with Hannah Liberman
                    </a>
                    &nbsp;for CultureBot
                  </p>
                </Col>
              </Row>
            </Container>
          </Tab.Content>
        </Row>
      </Tab.Container>
    </div>
  );
}

export default About;
